
<script>
import { Line, mixins } from "vue-chartjs";

export default {
  extends: Line,
  name: "OrdersChart",
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: null
    }
  },
  mixins: [mixins.reactiveProp],
  data() {
    return {};
  },
  methods: {
    refresh() {
      this.renderChart(this.chartData, this.options);
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>

<style scoped>
</style>